import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName } from '@carboncopyco/utils';
import { useState } from 'react';
import type { CsvParams } from '../../../../Dashboard/SessionBreakdownComponents/types';
import { DownloadCsvButton } from '../../../DownloadCsv';
import { TitleCard } from '../../../InfoPageCards/TitleCard';
import { useTourPageProps } from '../../TourPageContext';
import { ToursSessionsBreakdownTable } from './ToursSessionsBreakdownTable';

export const SessionsBreakdownCard = () => {
  const { organizationId } = useTourPageProps();
  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: {
      organizationId,
      timezone: getTimezoneName(),
      resourceTypes: ['tour'],
    },
    isDisabled: false,
  });
  return (
    <TitleCard
      radius
      border="ds-regular"
      header={
        <div className="h-ds-15 flex px-6 items-center justify-between">
          <TextLargeParagraph
            label="Session breakdown"
            color="text-ds-natural-600"
          />
          <DownloadCsvButton
            params={csvParams.params}
            disabled={csvParams.isDisabled}
            location="tour_info_page"
          />
        </div>
      }
    >
      <ToursSessionsBreakdownTable setCsvParams={setCsvParams} />
    </TitleCard>
  );
};
